import { ServiceFetch } from '../service-fetch'

export default class SalaryPaymentListModel extends ServiceFetch {
    getSalaryPaymentListBy = (data) => this.authFetch({
        url: 'salary-payment-list/getSalaryPaymentListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}